import React, {Component} from 'react';
import {
    getLocationFromGoogleByQuery,
    getDadata,
    dumpState,
} from 'api';
import transformGoogleGeocodedData from "../../../tools/transform-google-geocoded-data";
import ga from 'react-ga';
import GeneralStore from 'stores/GeneralStore';
import CategoryStore from 'stores/CategoryStore';
import RouteStore from 'stores/RouteStore';
import UserStore from 'stores/UserStore';
import InstantBookingStore from 'stores/InstantBookingStore';
import ActionCreators from 'actions/ActionCreators';
import Waypoint from 'components/Waypoint';
import Datepicker from 'components/DatepickerControl';
import Button from 'components/ButtonControl';
import Icon from 'components/IconControl';
import TimePane from 'components/TimePane';
import ProgressBarPane from 'components/ProgressBarPane';
import {translate as t} from 'lang';
import AnimakitExpander from 'animakit-expander'

import './RouteScreen.scss'

const ROUTES_SCREEN_PROGRESS_BAR_CONFIG = [true, true, true, true, true];
const LEFT_BUTTON_ARROW = <Icon name="leftArrow"/>;
const RIGHT_BUTTON_ARROW = <Icon name="rightArrow"/>;

function getStateFromStores() {
    return {
        locations: RouteStore.getLocations(),
        dates: RouteStore.getDates(),
        time: RouteStore.getTime(),
        countries: RouteStore.getCountries(),
        selectedCategory: CategoryStore.getSelected(),
        userHasToken: UserStore.hasToken(),
        userHasVVauthorization: UserStore.hasVVauthorization(),
        isEditMode: GeneralStore.isEditMode(),
        defaultCountry: GeneralStore.getDefaultCountryId(),
        showInstantBooking: InstantBookingStore.showInstantBooking(),
    };
}

class RouteScreen extends Component {

    constructor(props) {
        super(props);
        var storesState = getStateFromStores();

        this.state = {
            ...storesState,
            showDate: true,
            presetLocation: false,
            addressErrorMessageFrom: '',
            addressErrorMessageTo: '',
        };
    }

    componentDidMount() {
        RouteStore.addChangeListener(this._onChange);
        CategoryStore.addChangeListener(this._onChange);
        InstantBookingStore.addChangeListener(this._onChange);

        var fetchDadata = [];
        var countriesId = [];
        var queryFrom = this.props.location.query.from;
        var queryTo = this.props.location.query.to;
        var locations = this.state.locations;
        var defaultCountry = this.state.defaultCountry;

        if (!locations.from[0] && queryFrom) {
            fetchDadata.push(queryFrom);

            var countryId = locations.from[0] && locations.from[0].country ? locations.from[0] : defaultCountry;
            countriesId.push(countryId);
        }

        if (!locations.to[0] && queryTo) {
            fetchDadata.push(queryTo);

            var countryId = locations.to[0] && locations.to[0].country ? locations.to[0] : defaultCountry;
            countriesId.push(countryId);
        }

        if (fetchDadata.length > 0) {
            ActionCreators.showLoadingOverlay();

            Promise.all(fetchDadata.map((query, key) => {
                return getDadata(query, countriesId[key], 2).then((response_data) => {
                    if (Array.isArray(response_data.response)) {
                        var result = response_data.response;

                        if (result[0]) {
                            result[0].city = result[0].city;
                            result[0].city_full = result[0].city_full;
                            result[0].text = result[0].city_full;

                            return result[0];
                        }
                    }

                    return false;
                }).then((result) => {
                    return getLocationFromGoogleByQuery(result.country_name + ', ' + result.city_full).then(
                        async (done) => {
                            if (!done.results)
                                return false;
                            let resultItems = done.results;
                            if (resultItems[0]) {
                                let resultItem = resultItems[0];
                                let geocodedData = await transformGoogleGeocodedData(resultItem);
                                result.coords = [geocodedData.coords.lng, geocodedData.coords.lat];

                                return result;
                            }

                            return false;
                        },
                        error => {},
                    );
                });
            })).then((data) => {

                if (data[0]) {
                    locations.from[0] = data[0];
                } else {
                    locations.from[0] = {
                        country: defaultCountry,
                        city: queryFrom,
                        text: queryFrom,
                    };
                }

                if (data[1]) {
                    locations.to[0] = data[1];
                } else {
                    locations.to[0] = {
                        country: defaultCountry,
                        city: queryTo,
                        text: queryTo,
                    };
                }

                this.setState({
                    presetLocation: true,
                }, () => {

                    locations.from[0].need_calibration = false;
                    locations.to[0].need_calibration = false;

                    this._changeWaypoint.call(this, 'from', locations.from);
                    this._changeWaypoint.call(this, 'to', locations.to);

                    this.setState({
                        presetLocation: false,
                    });

                    ActionCreators.hideLoadingOverlay();
                });
            }).catch(() => {

                this.setState({
                    presetLocation: false,
                });

                ActionCreators.hideLoadingOverlay();
            });
        }

        ActionCreators.cancelTankmenValidation();
    }

    componentWillUnmount() {
        RouteStore.removeChangeListener(this._onChange);
        CategoryStore.removeChangeListener(this._onChange);
        InstantBookingStore.removeChangeListener(this._onChange);
    }

    _onChange = () => {
        this.setState(getStateFromStores());
    };

    _changeWaypoint(destination, waypoints) {
        ActionCreators.updateLocations({
            destination,
            waypoints,
        });
        ActionCreators.setInstantPriceDistance(0)
    }

    _onDateChange = (dates) => {
        dates.errors = {
            from: '',
            to: '',
        }

        ActionCreators.updateDates(dates)
    };

    _onTimeChange = (time) => {
        ActionCreators.updateTime(time)
    }

    _goToNextStep = () => {
        const analyticsRouteVisitParam = InstantBookingStore.getAnalyticsRouteVisitParams()

        if (window.ym) {
            const yaParams = {};
            yaParams.calendar_geo = analyticsRouteVisitParam
            window.ym('1315865', 'params', yaParams);
        }

        if (typeof window.ga === 'function') {
            window.ga('set', 'dimension11', analyticsRouteVisitParam)
        }

        ga.event({
            category: 'orders',
            action: 'add_orders_new_s3',
            label: this.state.selectedCategory.name,
        })

        if (
            this.state.showInstantBooking &&
            (
                this.state.selectedCategory.name === 'moving' ||
                this.state.selectedCategory.name === 'household'
            )
        ) {
            ActionCreators.setStage(`/category/${this.state.selectedCategory.id}/instant`, this.props.location.query)
        } else {
            ActionCreators.setStage(`/category/${this.state.selectedCategory.id}/params`, this.props.location.query)
        }
    }

    _onRoutesComplete = () => {
        const state = {}

        ActionCreators.showLoadingOverlay() ;
        RouteStore.normalizeState(state);

        ActionCreators
        .calibrateGoogleNormalizedLocations(state.locations)
        .then(calibratedLocations => {
            if (!calibratedLocations[0][1].coords) {
                this.setState({ addressErrorMessageFrom: 'Пожалуйста, выберите адрес из выпадающего списка' });

                ActionCreators.hideLoadingOverlay();

                return;
            }

            if (!calibratedLocations[0][2].coords) {
                this.setState({ addressErrorMessageTo: 'Пожалуйста, выберите адрес из выпадающего списка' });

                ActionCreators.hideLoadingOverlay();

                return;
            }

            if (calibratedLocations && calibratedLocations.length > 0) {
                return Promise.all(calibratedLocations.map(route => {
                    return Promise.all(Object.keys(route).map(key => {
                        return route[key];
                        /*
                        if( ('need_calibration' in route[key]) && route[key].need_calibration == false) {
                            return route[key];
                        }
                        else{
                            return getLocationFromGoogleByQuery(route[key].country_name + ', ' + route[key].city_full).then(
                                async (done) => {
                                    console.log(route[key]);
                                    console.log(route[key].country_name + ', ' + route[key].city_full);
                                    console.log(done);

                                    if (!done.results)
                                        return false;
                                    let resultItems = done.results;
                                    if (resultItems[0]) {
                                        let resultItem = resultItems[0];
                                        let geocodedData = await transformGoogleGeocodedData(resultItem);
                                        route[key].coords = [geocodedData.coords.lng, geocodedData.coords.lat];
                                    }
                                    return route[key]
                                },
                                error => {
                                    console.log('error');
                                    return route[key]
                                },
                            );
                        }
                        */
                    }))
                }))
            } else {
                return []
            }
        }).then(calibratedLocations => {
            if (calibratedLocations.length > 0) {
                calibratedLocations = calibratedLocations.map(route => {
                    if (!route[0] && !route[1]) {
                        return {}
                    }

                    let waypoint = {}

                    if (route[0]) {
                        waypoint[1] = route[0]
                    }

                    if (route[1]) {
                        waypoint[2] = route[1]
                    }

                    return waypoint
                })

                ActionCreators.showInstantBookingByNormalizedRoute(calibratedLocations)
            }
        })
        .finally(() => {
            return RouteStore
            .validate()
            .then(() => {
                ActionCreators.sendRoutesToGa()
                ActionCreators.sendDatesToGa()
                ActionCreators.hideLoadingOverlay()

                this._goToNextStep()
            })
            .catch(error => {
                ActionCreators.hideLoadingOverlay()

                if (!this.state.showInstantBooking) {
                    if (Object.keys(error.datesErrors).length > 0 &&
                        (error.datesErrors.from ||
                            error.datesErrors.to ||
                            !error.datesErrors.from ||
                            !error.datesErrors.to)) {

                        return
                    }
                }

                error.locationsErrors.from = error.locationsErrors.from.filter(item => item !== undefined)
                error.locationsErrors.to = error.locationsErrors.to.filter(item => item !== undefined)

                if ((error.locationsErrors.from && error.locationsErrors.from.length > 0) ||
                    (error.locationsErrors.to && error.locationsErrors.to.length) ||
                    !error.locationsErrors.from ||
                    !error.locationsErrors.to) {

                    return
                }

                this._goToNextStep()
            })
        })
    }

    _onTimeOnOff = () => {
        ga.event({
            category: 'fields',
            action: 'change_time_booking_step_4',
            label: this.state.selectedCategory.name,
            value: 1,
        })
    }

    _onIntervalOnOff = () => {
        ga.event({
            category: 'fields',
            action: 'change_time_interval',
            label: this.state.selectedCategory.name,
            value: 1,
        })
    }

    _onTimeFromChange = (from) => {
        ActionCreators.updateTime({from})

        ga.event({
            category: 'fields',
            action: 'time_from_list',
            label: this.state.selectedCategory.name,
            value: 1,
        })
    }

    _onTimeToChange = (to) => {
        ActionCreators.updateTime({to})

        ga.event({
            category: 'fields',
            action: 'time_to_list',
            label: this.state.selectedCategory.name,
            value: 1,
        })
    }

    _onFromMainMapSave = () => {
        ga.event({
            category: 'clicks',
            action: 'place_first_from_map',
            label: this.state.selectedCategory.name,
            value: 1,
        });
    };

    _onFromAdditionalMapSave = () => {
        ga.event({
            category: 'clicks',
            action: 'place_second_from_map',
            label: this.state.selectedCategory.name,
            value: 1,
        });
    };

    _onToMainMapSave = () => {
        ga.event({
            category: 'clicks',
            action: 'place_first_to_map',
            label: this.state.selectedCategory.name,
            value: 1,
        });
    };

    _onToAdditionalMapSave = () => {
        ga.event({
            category: 'clicks',
            action: 'place_second_to_map',
            label: this.state.selectedCategory.name,
            value: 1,
        });
    };

    _setStage = () => {
        var categoryId = this.state.selectedCategory.get('name');
        var stage = `/category/${categoryId}`;

        ga.event({
            category: 'buttons',
            action: 'click_button_return_s2_booking_step_3',
            label: categoryId,
            value: 1,
        })

        ActionCreators.setStage(stage, this.props.location.query);
    };

    _onEditComplete = () => {
        if (confirm(t('EDIT_ORDER_WARNING'))) {
            ActionCreators.showLoadingOverlay();

            RouteStore.validate().then(
                done => {
                    ActionCreators.submitUpdate()
                    .catch(error => {
                        ActionCreators.hideLoadingOverlay();

                        if (error === false) {
                            dumpState();
                            alert(t('SOMETHING_WENT_WRONG'));
                        } else if (typeof error === 'string') {
                            alert(t(error));
                        }
                    });
                },

                error => ActionCreators.hideLoadingOverlay(),
            );
        }
    };

    render() {
        const {locations, countries, dates, time, isEditMode} = this.state

        let datesErrors = null
        if ((dates.errors && dates.errors.from) || (dates.errors && dates.errors.to)) {
            datesErrors = (
                <div className="RouteScreen-dateErrors">
                    <div>{dates.errors.from ? t(dates.errors.from) : null}</div>
                    <div>{dates.errors.to && dates.errors.from !== dates.errors.to ? t(dates.errors.to) : null}</div>
                </div>
            )
        }

        return (
            <div>
                <div className="RouteScreen container">
                    <div className="RouteScreen-from">
                        <div className="RouteScreen-title">Откуда</div>
                        <Waypoint
                            addresses={locations.from}
                            countries={countries}
                            type="from"
                            presetLocation={this.state.presetLocation}
                            onChange={this._changeWaypoint.bind(this, 'from')}
                            showAdditionalAddress={locations.from[1] !== undefined}
                            onMainMapSave={this._onFromMainMapSave.bind(this)}
                            onAdditionalMapSave={this._onFromAdditionalMapSave.bind(this)}
                            defaultCountry={this.state.defaultCountry}
                            errorMessage={this.state.addressErrorMessageFrom}
                        />
                    </div>
                    <div className="RouteScreen-to">
                        <div className="RouteScreen-title">Куда</div>
                        <Waypoint
                            addresses={locations.to}
                            countries={countries}
                            type="to"
                            presetLocation={this.state.presetLocation}
                            onChange={this._changeWaypoint.bind(this, 'to')}
                            showAdditionalAddress={locations.to[1] !== undefined}
                            onMainMapSave={this._onToMainMapSave.bind(this)}
                            onAdditionalMapSave={this._onToAdditionalMapSave.bind(this)}
                            defaultCountry={this.state.defaultCountry}
                            errorMessage={this.state.addressErrorMessageTo}
                        />
                    </div>
                    <AnimakitExpander expanded={!this.state.showInstantBooking} duration={200}>
                        <div className="RouteScreen-date">
                            <div className="RouteScreen-dateSwitch RouteScreen-field">
                                <div className="RouteScreen-dateTitle">Дата погрузки</div>
                            </div>
                            {datesErrors}
                            <div>
                                <Datepicker className="RouteScreen-datepicker"
                                            from={dates.from}
                                            to={dates.to}
                                            position="bottom"
                                            onChange={this._onDateChange}/>
                                <TimePane className="RouteScreen-time"
                                          onChange={this._onTimeChange}
                                          valueFrom={time.from}
                                          valueTo={time.to}
                                          onTimeOnOff={this._onTimeOnOff.bind(this)}
                                          onIntervalOnOff={this._onIntervalOnOff.bind(this)}
                                          onTimeFromChange={this._onTimeFromChange.bind(this)}
                                          onTimeToChange={this._onTimeToChange.bind(this)}/>
                            </div>
                            {dates.from && dates.from === dates.to && (
                                <span className="RouteScreen-dateNotice">Пожалуйста, укажите диапазон дат начала отгрузки Ваших грузов. Для этого последовательно выберите начальную и конечную даты диапазона отгрузки. Выбор одной единственной даты отгрузки существенно снизит шансы на поиск надежного перевозчика.</span>
                            )}
                        </div>
                    </AnimakitExpander>
                </div>
                <div className="container">
                    <div className="RouteScreenControls">
                        <Button
                            className="RouteScreenControls-back"
                            view="stone"
                            size="s"
                            leftIcon={LEFT_BUTTON_ARROW}
                            onClick={this._setStage}>
                            {t('BACK')}
                        </Button>
                        <Button
                            className="RouteScreenControls-next"
                            view="sand"
                            shadow={false}
                            size="m"
                            rightIcon={RIGHT_BUTTON_ARROW}
                            onClick={this._onRoutesComplete}>
                            {t('NEXT_STEP')}
                        </Button>
                        {isEditMode ?
                            <Button
                                className="RouteScreenControls-submitUpdate"
                                view="forest"
                                size="m"
                                onClick={this._onEditComplete}>
                                {t('SAVE')}
                            </Button> : null}
                    </div>
                    <div className="clearfix"></div>
                    <ProgressBarPane linkActive={ROUTES_SCREEN_PROGRESS_BAR_CONFIG} location={this.props.location}/>
                </div>
            </div>
        );
    }
}

export default RouteScreen;



// WEBPACK FOOTER //
// ./client/components/RouteScreen/RouteScreen.js